import { z } from 'zod';

export const MetadataSchema = z.object({
  domain: z.string(),
});

export type Metadata = z.infer<typeof MetadataSchema>;
